export default __webpack_public_path__ + "static/media/SPEKTRA_PROSPEKTUS_optimiseer.8a73ed06.pdf";